import React from 'react'
import { Form } from './form'
import { Link } from 'react-router-dom'
import { X } from 'react-feather'
import { useDispatch } from 'react-redux'
import styles from '../../login/components/content.module.css'
import { useInternationalization } from '../../../features/i18n'
import { setPopupContent } from '../../../features/account/slice'
import { useViewport } from '../../../utils'

const Content = ({embed, onClose, noRedirect}) => {
  const dispatch = useDispatch()
  const { isDesktop } = useViewport()
  const { translate } = useInternationalization()

  return (
    <div className={`w-full lg:w-10/12 mx-auto ${embed ? 'py-8' : 'min-h-screen'} h-full flex items-center`}>
      <div className={`w-full bg-white lg:rounded h-full lg:h-auto ${embed ? '' : 'relative'} ${embed ? '' : styles['wrapper']}`}>
        {
          embed ? (
            <p className="absolute top-0 right-0 p-5" onClick={onClose}>
              <X/>
            </p>
          ) : <>
            {
              isDesktop && <>
                <Link to="/" className="absolute top-0 right-0 p-5">
                  <X/>
                </Link>
              </>
            }
          </>
        }
        <div className="flex flex-wrap -mx-4">
          <div className="mx-auto lg:mx-0 w-1/2 px-4 h-auto pt-24">
            <img src="/images/khub_signup.png" alt="sign up" className="mx-auto mb-5 lg:mb-0 lg:mx-0 lg:mr-auto lg:w-10/12"/>
          </div>
          <div className="md:w-10/12 lg:w-1/2 md:mx-auto lg:mx-0 px-4">
            <h1 className="text-3xl lg:text-4xl text-center lg:text-left font-bold font-accent mb-5 lg:mb-8 uppercase">
              {translate('AUTH', 'sign_up')}
            </h1>

            <Form className="mb-5 lg:mb-8" noRedirect={noRedirect} onClose={onClose} embed={embed}/>

            <p className="text-gray-444 text-sm text-center lg:text-left">
              {translate('AUTH', 'already_member')} {embed ? (
                <span className="link underline text-primary" onClick={() => dispatch(setPopupContent('login'))}>
                  {translate('AUTH', 'login')}
                </span>
              ) : (
                <Link to="/login" className="link underline text-primary">{translate('AUTH', 'login')}</Link>
              )}
            </p>
          </div>
        </div>

        <hr className={`${styles['separator']}`}/>

        <div className="text-center lg:text-lg mb-5 lg:mb-0 text-gray-444">
          {translate('AUTH', 'have_organization')} {embed ? (
            <span onClick={onClose}><Link to="/register-organization" className="text-secondary underline">
              {translate('AUTH', 'sign_up_here')}
            </Link></span>
          ) : (
            <Link to="/register-organization" className="text-secondary underline">
              {translate('AUTH', 'sign_up_here')}
            </Link>
          )}
        </div>
      </div>
    </div>
  )
}

export { Content }
